export default function menucollapsed(state = true, action){
  if (action.type === 'iscollapsed') {
    return state = true;
  } else if (action.type === 'isntcollapsed') {
    return state = false;
  } else {
    return state;
  }
}
